import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'
import clsx from 'clsx'

import NavBar from './components/NavBar'
import { useMediaQuery } from '@material-ui/core'
import { sendPageView } from './utils/AnalyticsUtils'
import { ProtectedRoute } from '@dentalux/security'
import { useTranslation } from 'react-i18next'

import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import MomentUtils from '@date-io/moment'
import moment from 'moment'
import SalaryCalculation from './pages/SalaryCalculation'

const useStyles = makeStyles((theme) =>
  createStyles({
    appBar: {
      background: theme.palette.common.white,
      color: theme.palette.common.black,
      zIndex: theme.zIndex.drawer + 1,
    },
    sideNav: {
      top: 'inherit',
      width: 80,
    },
    menuTab: {
      minWidth: 80,
    },
    content: {
      flexGrow: 1,
      padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
    },
    contentShrink: {
      margin: 20,
    },
    tooltip: {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.text.primary,
      boxShadow: theme.shadows[1],
      fontSize: theme.typography.fontSize,
    },
  })
)

const Main = () => {
  const [t, i18n] = useTranslation()
  const classes = useStyles()
  const location = useLocation()
  const [navItems, setNavItems] = useState<React.ReactNode>(null)

  const screenSizeDetection = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'))
  const [open, setOpen] = useState(screenSizeDetection)

  const handleMenuClose = () => {
    setOpen(!open)
  }

  useEffect(() => {
    setOpen(screenSizeDetection)
  }, [screenSizeDetection])

  useEffect(() => sendPageView(location), [location])

  return (
    <div>
      <MuiPickersUtilsProvider utils={MomentUtils} locale={i18n.language} libInstance={moment}>
        <NavBar className={classes.appBar} handleMenuClose={handleMenuClose} navItems={navItems} />
        <main
          className={clsx(classes.content, {
            [classes.contentShrink]: open,
          })}
        >
          <ProtectedRoute path="">
            <SalaryCalculation />
          </ProtectedRoute>
        </main>
      </MuiPickersUtilsProvider>
    </div>
  )
}

export default Main
